import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  praDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './generate-pra-report-dialog.controller';
import template from './generate-pra-report-dialog.html';

// Validation
import assessmentGenerateFullReportMessagesTpl from './assessment.generate.full.report.messages.html';


class dialogService {
  getOptions($event, { assessment, settings }) {
    return {
      controller,
      controllerAs: 'fullReportDialogVM',
      locals: {
        assessment,
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.generatePRAReportDialog', [
  ngCookies,
  praDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('generatePRAReportDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.generate.full.report.messages.html', assessmentGenerateFullReportMessagesTpl);
  })
  .name;
